import { useEffect, useMemo } from 'react'

const AUTO_LOGIN_GAP = 10000

function Login() {
  const isMobile = useMemo(() => /iphone|android|ipad|mobile|wxwork/i.test(navigator.userAgent), [])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    if (code) {
      window.location.href = `/okr/?code=${code}`
      return
    }

    if (!isMobile) return

    const lastAttemptAt = Number(sessionStorage.getItem('wxwork_auto_login_at') || '0')
    const now = Date.now()

    if (now - lastAttemptAt < AUTO_LOGIN_GAP) return

    sessionStorage.setItem('wxwork_auto_login_at', String(now))
    window.location.replace('/okr/api/wxwork/auth')
  }, [isMobile])

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>团队目标管理系统</h1>
        <p className="subtitle">信息管理部 - 目标管理、工作日志、自动报告</p>
        
        <div className="login-card">
          <h2>企业微信登录</h2>
          <p>{isMobile ? '正在自动进入企业微信登录，如未自动跳转可点击下方按钮继续。' : '请使用企业微信扫码或点击下方按钮登录'}</p>
          
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <a className="wxwork-login-btn" href="/okr/api/wxwork/auth" rel="noreferrer">
              {isMobile ? '企业微信登录' : '企业微信登录（自动识别终端）'}
            </a>
            {!isMobile && (
              <a
                className="wxwork-login-btn"
                href="https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=wwdd82a0ef8ccc9f81&agentid=1000115&redirect_uri=https%3A%2F%2Fokr.gs-robot.com%2Fokr%2Fapi%2Fwxwork%2Fcallback&state=okr"
                target="_blank"
                rel="noreferrer noopener"
              >
                PC 扫码登录（直连官方扫码页）
              </a>
            )}
          </div>

          {!isMobile && (
            <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
              若按钮无反应，可复制粘贴到浏览器打开：<br />
              <code>https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=wwdd82a0ef8ccc9f81&agentid=1000115&redirect_uri=https%3A%2F%2Fokr.gs-robot.com%2Fokr%2Fapi%2Fwxwork%2Fcallback&state=okr</code>
            </p>
          )}
          
          <div className="features">
            <h3>系统功能：</h3>
            <ul>
              <li>📊 年度KPI分解与跟踪</li>
              <li>📝 工作日志记录（支持截图上传）</li>
              <li>🔗 语雀文档智能关联</li>
              <li>📈 自动周报生成</li>
              <li>📱 PWA支持，移动端友好</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-note">
          <p>© 2026 信息管理部 | 技术支持：AI助理</p>
        </div>
      </div>
    </div>
  )
}

export default Login